import { PayloadModel } from "@/services/http/payloadModel";

export interface UserPayloadInterface {
  firstName: string;
  lastName: string;
  email: string;
  organization: string;
  tosAgreement: boolean;
  phoneNumber: string;
  tier: string;
  awsMarketplaceToken?: string;
  stagedLicenseToken?: string;
}

export class UserPayload
  implements UserPayloadInterface, PayloadModel<UserPayloadInterface>
{
  firstName = "";
  lastName = "";
  email = "";
  organization = "";
  tosAgreement = false;
  phoneNumber = "";
  tier = "";
  awsMarketplaceToken: undefined | string;
  stagedLicenseToken: undefined | string;

  constructor(payload: UserPayloadInterface) {
    this.firstName = payload.firstName;
    this.lastName = payload.lastName;
    this.email = payload.email;
    this.organization = payload.organization;
    this.tosAgreement = payload.tosAgreement;
    this.phoneNumber = payload.phoneNumber;
    this.tier = payload.tier;
    this.awsMarketplaceToken = payload.awsMarketplaceToken;
    this.stagedLicenseToken = payload.stagedLicenseToken;
  }

  getPayload(): UserPayloadInterface {
    const payload: UserPayloadInterface = {
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      organization: this.organization,
      tosAgreement: this.tosAgreement,
      phoneNumber: this.phoneNumber,
      tier: this.tier,
    };

    if (this.awsMarketplaceToken && this.awsMarketplaceToken.length) {
      payload.awsMarketplaceToken = this.awsMarketplaceToken;
    }

    if (this.stagedLicenseToken && this.stagedLicenseToken.length) {
      payload.stagedLicenseToken = this.stagedLicenseToken;
    }

    return payload;
  }
}
